<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :span="12">
            <a-form-item
              :label="$t(I18N_KEY.CUSTCONVERTREAL + 'dataDt')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 14, offset: 1 }"
            >
              <a-range-picker v-model="queryParam.dataDt" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.CUSTCONVERTREAL + 'productType')">
              <a-select v-model="queryParam.appssid">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="7" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{
                $t(I18N_KEY.CUSTCONVERTREAL + 'query')
              }}</a-button>
              <a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{
                $t('exportFile')
              }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <a-table
        ref="table"
        size="middle"
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :scroll="{ x: 2300, y: 2000 }"
        bordered
        @change="handleTableChange"
        @expand="extpand"
      >
        <a-table
          slot="expandedRowRender"
          slot-scope="text"
          ref="table"
          size="middle"
          :columns="innerColumns"
          :data-source="text.dataDetails"
          :loading="loading"
          :pagination="false"
          bordered
        >
        </a-table>
      </a-table>
    </div>
    <RefundTradeModal ref="modalForm" @ok="modalFormOk"></RefundTradeModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplistExcludingSubApp, getConvertRealData } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'

const I18N_KEY = {
  CUSTCONVERTREAL: 'custConvertReal.',
}

export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict,
  },
  data() {
    return {
      I18N_KEY,
      visible: false,
      REFUND_TRADE_STATUS,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },

      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      innerData: [],
      appList: [],
      // Query conditions
      queryParam: {
        dataDt: [moment().add('days', -60), moment().add('days', 0)],
        appssid: '',
      },
      loading: false,

      innerData: [],

      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  created() {
    this.loadData(1)
    getApplistExcludingSubApp().then((res) => {
      this.appList = res.data || []
    })
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'dataDt'),
          align: 'left',
          dataIndex: 'dataDt',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'appName'),
          align: 'left',
          dataIndex: 'appName',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installs'),
          align: 'left',
          dataIndex: 'installs',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regCount'),
          align: 'left',
          dataIndex: 'regCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'basicCount'),
          align: 'left',
          dataIndex: 'basicCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'workCount'),
          align: 'left',
          dataIndex: 'workCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkmanCount'),
          align: 'left',
          dataIndex: 'linkmanCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonCount'),
          align: 'left',
          dataIndex: 'jsonCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idimageCount'),
          align: 'left',
          dataIndex: 'idimageCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceCount'),
          align: 'left',
          dataIndex: 'faceCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idnoCount'),
          align: 'left',
          dataIndex: 'idnoCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankcardCount'),
          align: 'left',
          dataIndex: 'bankcardCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyCount'),
          align: 'left',
          dataIndex: 'applyCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'accessCount'),
          align: 'left',
          dataIndex: 'accessCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'loanCount'),
          align: 'left',
          dataIndex: 'loanCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'optRegRate'),
          align: 'left',
          dataIndex: 'optRegRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regApplyRate'),
          align: 'left',
          dataIndex: 'regApplyRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installApplyRate'),
          align: 'left',
          dataIndex: 'installApplyRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyAccessRate'),
          align: 'left',
          dataIndex: 'applyAccessRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'baseBeforeRate'),
          align: 'left',
          dataIndex: 'baseBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'workBeforeRate'),
          align: 'left',
          dataIndex: 'workBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkBeforeRate'),
          align: 'left',
          dataIndex: 'linkBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonBeforeRate'),
          align: 'left',
          dataIndex: 'jsonBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idCardBeforeRate'),
          align: 'left',
          dataIndex: 'idCardBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceBeforeRate'),
          align: 'left',
          dataIndex: 'faceBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankCardBeforeRate'),
          align: 'left',
          dataIndex: 'bankCardBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyBeforeRate'),
          align: 'left',
          dataIndex: 'applyBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'loanBeforeRate'),
          align: 'left',
          dataIndex: 'loanBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'cardRegisterRate'),
          align: 'left',
          dataIndex: 'cardRegisterRate',
        },
      ]
    },
    innerColumns() {
      return [
        {
          title: 'Category',
          align: 'left',
          dataIndex: 'appVersion',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installs'),
          align: 'left',
          dataIndex: 'installs',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regCount'),
          align: 'left',
          dataIndex: 'regCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'basicCount'),
          align: 'left',
          dataIndex: 'basicCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'workCount'),
          align: 'left',
          dataIndex: 'workCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkmanCount'),
          align: 'left',
          dataIndex: 'linkmanCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonCount'),
          align: 'left',
          dataIndex: 'jsonCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idimageCount'),
          align: 'left',
          dataIndex: 'idimageCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceCount'),
          align: 'left',
          dataIndex: 'faceCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idnoCount'),
          align: 'left',
          dataIndex: 'idnoCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankcardCount'),
          align: 'left',
          dataIndex: 'bankcardCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyCount'),
          align: 'left',
          dataIndex: 'applyCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'accessCount'),
          align: 'left',
          dataIndex: 'accessCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'loanCount'),
          align: 'left',
          dataIndex: 'loanCount',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'optRegRate'),
          align: 'left',
          dataIndex: 'optRegRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'regApplyRate'),
          align: 'left',
          dataIndex: 'regApplyRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'installApplyRate'),
          align: 'left',
          dataIndex: 'installApplyRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyAccessRate'),
          align: 'left',
          dataIndex: 'applyAccessRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'baseBeforeRate'),
          align: 'left',
          dataIndex: 'baseBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'workBeforeRate'),
          align: 'left',
          dataIndex: 'workBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'linkBeforeRate'),
          align: 'left',
          dataIndex: 'linkBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'jsonBeforeRate'),
          align: 'left',
          dataIndex: 'jsonBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'idCardBeforeRate'),
          align: 'left',
          dataIndex: 'idCardBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'faceBeforeRate'),
          align: 'left',
          dataIndex: 'faceBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'bankCardBeforeRate'),
          align: 'left',
          dataIndex: 'bankCardBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'applyBeforeRate'),
          align: 'left',
          dataIndex: 'applyBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'loanBeforeRate'),
          align: 'left',
          dataIndex: 'loanBeforeRate',
        },
        {
          title: this.$t(I18N_KEY.CUSTCONVERTREAL + 'cardRegisterRate'),
          align: 'left',
          dataIndex: 'cardRegisterRate',
        },
      ]
    },
  },
  methods: {
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      getConvertRealData(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.ipagination.total = res.data.total
            this.dataSource = res.data.rows
          } else {
            this.ipagination.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.pageSize
      return filterObj(data)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO Filter
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    extpand(expanded, record) {
      // if(expanded){
      //   this.innerData = record.dataDetails;
      //
      //   console.log("------------->" + record);
      // } else {
      //   this.innerData = [];
      //   console.log("-------------> im close");
      // }
    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = 'Add new'
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    getUrl() {
      var params = this.getQueryParams() // Query conditions
      var url =
        '/api/web/webpublic/statistics/convertRealDataExcel?startDate=' +
        params.startDate +
        '&endDate=' +
        params.endDate

      if (params.appssid) {
        url += '&appssid=' + params.appssid
      }
      if (params.dataType) {
        url += '&dataType=' + params.dataType
      }
      return url
    },
    downLoadData() {
      const file = {
        fileUrl: this.getUrl(),
        fileName: 'convertDataExcel.xls',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
